<template>
  <div>
    <b-row class="align-items-center mx-0">
      <b-form-group
        label="Tipos de Instituições"
        :state="validateState()"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-checkbox-group
          v-model="selectedOptions"
          stacked
          name="tipos_instituicoes"
          :options="formattedInstituicoes"
          :aria-describedby="ariaDescribedby"
        />
        <b-form-invalid-feedback :state="validateState()">
          Selecione pelo menos um tipo de instituição
        </b-form-invalid-feedback>
      </b-form-group>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import safeArray from "lodash/toArray";

import TiposInstituicoes from "@/modules/clientes/Components/Form/TiposInstituicoes.vue";
import { modelValue } from "@/mixins/modelValue";

export default {
  mixins: [validationMixin, modelValue("value", "change")],
  components: { TiposInstituicoes },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    instituicoes: [],
  }),
  validations: {
    value: {
      required,
    },
  },
  computed: {
    formattedInstituicoes() {
      return safeArray(this.instituicoes).map((instituicao) => ({
        text: instituicao.nome,
        value: instituicao.id,
      }));
    },
    selectedOptions: {
      get() {
        return safeArray(this.modelValue).map((instituicao) =>
          typeof instituicao === "number" ? instituicao : instituicao.id
        );
      },
      set(value) {
        this.modelValue = value;
      },
    },
  },
  methods: {
    ...mapActions("tipos_instituicoes", ["ActionFind"]),
    validateState() {
      const { $dirty, $error } = this.$v.value;
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
    reset() {
      this.$v.$reset();
    },
  },
  async created() {
    const response = await this.ActionFind({ per_page: 100 });
    this.instituicoes = response.data;
  },
};
</script>
